<template>
    <div>
      <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
       -->
      <v-tabs v-model="activetab" align-with-title class="mt-n2 pb-0 tab-headers-details">
        <!-- eslint-disable-next-line max-len -->
        <v-tab v-for="tab of tabs" class="common-font-size" :key="tab.id" @click="WarnUser(tab.to)" :id="`mtgTransSequenceTab${tab.id}`"
          :class="`mtg-trans-sequence-tab-${tab.id}`">
          <span>{{ tab.caption }}</span>
        </v-tab>
      </v-tabs>
      <router-view />
    </div>
  </template>

<script>
import '../assets/style.css';
import CommonDropDownsMixins from '../components/tax/common-utils/CommonDropDowns.mixin.vue';

export default {
  name: 'taxRollWorkFile',
  mixins: [CommonDropDownsMixins],
  components: {
  },
  created() {
    this.getPathName(this.$route.path);
    this.loadDropDownList();
  },
  updated() {
    this.getPathName(this.$route.path);
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/tax/trworkfile/createTrWorkFile' }, caption: 'Create' },
      { id: 2, to: { path: '/tax/trworkfile/browse' }, caption: 'Browse' },
      { id: 3, to: { path: '/tax/trworkfile/FeeManagement' }, caption: 'Fee Management' },
    ],
  }),
  methods: {
    async loadDropDownList() {
      const criteria = { limit: 100, skip: 0 };
      await this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      await this.loadTaxMortgageCodesSharedRecords(
        {
          criteria: {
            ...criteria,
            sortBy: [{
              column: 'mtgCode',
              direction: 'asc',
            }],
          },
          postProcessTrans: this.postProccessMTGData,
          isItSetState: true,
        },
      );
      await this.loadTaxStatusCodesSharedRecords(
        {
          criteria: {
            sortBy: [{
              column: 'statusCode',
              direction: 'asc',
            }],
          },
          postProcessTrans: this.postProccessStatusCodesData,
          isItSetState: true,
        },
      );
      this.loadtaxAdjTypesSharedRecords({
        criteria: {},
        postProcessTrans: this.postProccessAdjTypesData,
        baseCrudKey: 'taxAdjTypesList',
      });
      await this.loadTaxFeeMasterTypes({
        criteria: { sortBy: [{ column: 'feeNumber', direction: 'asc' }] },
        postProcessTrans: this.postProccessTaxFeeData,
        baseCrudKey: 'sharedTaxFeeMaster',
      });
      this.loadCommentTypes({
        criteria: { sortBy: [{ column: 'commentCode', direction: 'asc' }] },
        postProcessTrans: this.postProccessCommentsCategoryData,
        baseCrudKey: 'sharedTaxComments',
      });
      this.loadTaxDistrict({
        criteria: {
          sortBy: [{
            column: 'districtCode',
            direction: 'asc',
          }],
        },
        baseCrudKey: 'sharedTaxDistrict',
      });
    },
    getPathName(curPath) {
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      this.activetab = ftr[0].id !== undefined ? ftr[0].id - 1 : 0;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },
  // computed: {
  // },
};
</script>
